export default __webpack_public_path__ + "c404884a6bbac05937d3e67b3e10114b.png";